import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog
  },
  props: {
    projectsCount: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      saving: false,
      phases: [{
        name: ''
      }]
    };
  },
  methods: {
    removePhase: function removePhase(index) {
      this.phases.splice(index, 1);
    },
    addNewPhase: function addNewPhase() {
      this.phases.push({
        name: ''
      });
    }
  }
};